"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var hooks_1 = require("../../../../../hooks");
var ConfigProvider_1 = require("../../../../../providers/ConfigProvider");
var either_1 = require("../../../../../utils/either");
var Button_1 = __importDefault(require("../../../../Button/Button"));
var LoupeIcon_1 = __importDefault(require("../../../../Icon/LoupeIcon"));
var Padder_1 = require("../../../../Padder");
var Form_1 = __importDefault(require("../../../Form"));
var Dropdown_1 = __importDefault(require("../../../inputs/Dropdown"));
var CasteZadavateleForm_1 = require("./CasteZadavateleForm");
var CasteZadavateleOption_1 = __importDefault(require("./CasteZadavateleOption"));
var StyledCasteZadavateleOption = styled_components_1.default(CasteZadavateleOption_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #fff;\n  padding: 1rem;\n  position: relative;\n"], ["\n  background-color: #fff;\n  padding: 1rem;\n  position: relative;\n"])));
var mapToOptions = ramda_1.map(function (zadavatel) { return ({
    value: zadavatel.id,
    label: zadavatel.nazev || undefined,
    data: zadavatel,
    render: react_1.default.createElement(CasteZadavateleOption_1.default, { zadavatel: zadavatel }),
}); });
var OvmZadavateleForm = function (_a) {
    var onSubmit = _a.onSubmit, labels = _a.labels, setSelected = _a.setSelected, filterResult = _a.filterResult, defaultSelected = _a.defaultSelected, isPosudek = _a.isPosudek;
    var iszrUrl = ConfigProvider_1.useConfig().iszrUrl;
    var token = hooks_1.useToken();
    var entityName = token.getDataFromToken().entityName;
    var getJSON = hooks_1.useGetJSON(iszrUrl + "/ovmseek");
    var postISZR = hooks_1.usePostJSON(iszrUrl + "/vyhledejosobu");
    var loadOptions = function (search) { return __awaiter(void 0, void 0, void 0, function () {
        var getParams, postParams, response, resultIco, resultDs, filteredResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!search) return [3 /*break*/, 6];
                    getParams = {
                        keyword: search,
                    };
                    postParams = {
                        systemId: isPosudek ? 'Znalci' : 'Tlumocnici',
                        uzivatel: entityName,
                    };
                    return [4 /*yield*/, getJSON(getParams)];
                case 1:
                    response = _a.sent();
                    if (!(either_1.isRight(response) && response.value.length === 0)) return [3 /*break*/, 5];
                    if (!(/^\d*$/.test(search) && search.length > 3 && search.length < 9)) return [3 /*break*/, 3];
                    return [4 /*yield*/, postISZR(__assign(__assign({}, postParams), { ico: search }))];
                case 2:
                    resultIco = _a.sent();
                    if (either_1.isRight(resultIco))
                        response.value = __spreadArrays(response.value, resultIco.value);
                    _a.label = 3;
                case 3:
                    if (!(search.length === 7)) return [3 /*break*/, 5];
                    return [4 /*yield*/, postISZR(__assign(__assign({}, postParams), { idds: search }))];
                case 4:
                    resultDs = _a.sent();
                    if (either_1.isRight(resultDs))
                        response.value = __spreadArrays(response.value, resultDs.value);
                    _a.label = 5;
                case 5:
                    if (either_1.isRight(response)) {
                        filteredResult = filterResult ? ramda_1.filter(filterResult, response.value) : response.value;
                        return [2 /*return*/, mapToOptions(filteredResult)];
                    }
                    _a.label = 6;
                case 6: return [2 /*return*/, []];
            }
        });
    }); };
    return (react_1.default.createElement(Form_1.default, { initialValues: { selected: defaultSelected }, validate: function (v) { return (!v.selected ? { selected: (labels === null || labels === void 0 ? void 0 : labels.search) && "" + (labels === null || labels === void 0 ? void 0 : labels.search) + '.' } : {}); }, onSubmit: function (values, helpers) {
            if (values.selected) {
                onSubmit(values.selected, helpers);
            }
        } }, function (_a) {
        var isSubmitting = _a.isSubmitting, setFieldValue = _a.setFieldValue, values = _a.values;
        return (react_1.default.createElement(Padder_1.Padder, null,
            (labels === null || labels === void 0 ? void 0 : labels.title) && react_1.default.createElement(CasteZadavateleForm_1.DropdownHeader, null, labels === null || labels === void 0 ? void 0 : labels.title),
            react_1.default.createElement(CasteZadavateleForm_1.DropdownWrap, null, values.selected ? (react_1.default.createElement(StyledCasteZadavateleOption, { zadavatel: values.selected, onRemove: function () {
                    setFieldValue('selected', undefined);
                    if (setSelected)
                        setSelected(undefined);
                } })) : (react_1.default.createElement(Dropdown_1.default, { name: "selected", isSearchable: true, placeholder: labels === null || labels === void 0 ? void 0 : labels.search, value: values.selected, onChange: function (_v, option) {
                    setFieldValue('selected', option.data);
                    if (setSelected)
                        setSelected(option.data);
                }, loadOptions: loadOptions, rightIcon: react_1.default.createElement(LoupeIcon_1.default, null) }))),
            react_1.default.createElement(CasteZadavateleForm_1.ButtonsWrap, null,
                react_1.default.createElement(Button_1.default, { type: "submit", primary: true, loading: isSubmitting, name: "PridatOsobu" }, (labels === null || labels === void 0 ? void 0 : labels.submit) || 'Přidat'))));
    }));
};
OvmZadavateleForm.defaultProps = {
    labels: {
        title: undefined,
        submit: 'Přidat',
        search: undefined,
    },
    filterResult: undefined,
    setSelected: undefined,
    defaultSelected: undefined,
};
exports.default = OvmZadavateleForm;
var templateObject_1;
